// Assessment question pool
// These questions will be randomly selected for each candidate

import { toast } from 'sonner';

// Map to store job-specific questions by area
const jobSpecificQuestions = new Map<string, {
  mcq: any[],
  descriptive: any[],
  personality: any[]
}>();

// Default MCQ questions
export const assessmentQuestionPool = {
  mcq: [
    {
      id: 'q1',
      question: 'Which of the following is NOT a feature of React?',
      options: [
        { id: 'a', text: 'Virtual DOM' },
        { id: 'b', text: 'Built-in state management like Redux' },
        { id: 'c', text: 'Component-based architecture' },
        { id: 'd', text: 'JSX syntax' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q2',
      question: 'What is the time complexity of searching in a balanced binary search tree?',
      options: [
        { id: 'a', text: 'O(1)' },
        { id: 'b', text: 'O(log n)' },
        { id: 'c', text: 'O(n)' },
        { id: 'd', text: 'O(n log n)' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q3',
      question: 'Which CSS property is used for creating responsive designs?',
      options: [
        { id: 'a', text: 'max-width' },
        { id: 'b', text: 'width' },
        { id: 'c', text: 'pixel-ratio' },
        { id: 'd', text: 'media queries' }
      ],
      correctAnswer: 'd'
    },
    {
      id: 'q4',
      question: 'What is the purpose of the useEffect hook in React?',
      options: [
        { id: 'a', text: 'To create a new state variable' },
        { id: 'b', text: 'To handle side effects in functional components' },
        { id: 'c', text: 'To optimize rendering performance' },
        { id: 'd', text: 'To create a controlled form input' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q5',
      question: 'Which of the following is a WebSocket library for React applications?',
      options: [
        { id: 'a', text: 'Axios' },
        { id: 'b', text: 'Fetch API' },
        { id: 'c', text: 'Socket.io' },
        { id: 'd', text: 'XMLHttpRequest' }
      ],
      correctAnswer: 'c'
    },
    {
      id: 'q6',
      question: 'What is the correct way to pass data from a parent component to a child component in React?',
      options: [
        { id: 'a', text: 'Using global variables' },
        { id: 'b', text: 'Using React context for all component communication' },
        { id: 'c', text: 'Using props' },
        { id: 'd', text: 'Using Redux for all component communication' }
      ],
      correctAnswer: 'c'
    },
    {
      id: 'q7',
      question: 'Which of the following is a valid way to create a React component?',
      options: [
        { id: 'a', text: 'const MyComponent = () => { return <div>Hello</div> }' },
        { id: 'b', text: 'function MyComponent() { render(<div>Hello</div>) }' },
        { id: 'c', text: 'class MyComponent { render() { return <div>Hello</div> } }' },
        { id: 'd', text: 'var MyComponent = function() => <div>Hello</div>' }
      ],
      correctAnswer: 'a'
    },
    {
      id: 'q8',
      question: 'What does the "key" prop do in React lists?',
      options: [
        { id: 'a', text: 'It defines CSS styles for list items' },
        { id: 'b', text: 'It helps React identify which items have changed, are added, or removed' },
        { id: 'c', text: 'It sets the text content of list items' },
        { id: 'd', text: 'It determines the order of list items' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q9',
      question: 'Which hook would you use to perform data fetching in a functional component?',
      options: [
        { id: 'a', text: 'useData' },
        { id: 'b', text: 'useFetch' },
        { id: 'c', text: 'useEffect' },
        { id: 'd', text: 'useApi' }
      ],
      correctAnswer: 'c'
    },
    {
      id: 'q10',
      question: 'What is the correct way to handle form submissions in React?',
      options: [
        { id: 'a', text: 'Use the form\'s action attribute to submit to a server' },
        { id: 'b', text: 'Capture the submit event and handle it with JavaScript' },
        { id: 'c', text: 'Always use a backend framework to handle forms' },
        { id: 'd', text: 'Forms cannot be handled in React' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q11',
      question: 'What is the purpose of the useState hook in React?',
      options: [
        { id: 'a', text: 'To declare a static variable' },
        { id: 'b', text: 'To create and update state in functional components' },
        { id: 'c', text: 'To connect to a database' },
        { id: 'd', text: 'To define component props' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q12',
      question: 'Which of the following is TRUE about RESTful APIs?',
      options: [
        { id: 'a', text: 'They always return XML data' },
        { id: 'b', text: 'They are stateful' },
        { id: 'c', text: 'They use resources as endpoints' },
        { id: 'd', text: 'They only support GET requests' }
      ],
      correctAnswer: 'c'
    },
    {
      id: 'q13',
      question: 'What is the purpose of a CSS preprocessor like SASS or LESS?',
      options: [
        { id: 'a', text: 'To convert JavaScript to CSS' },
        { id: 'b', text: 'To add variables, nesting, mixins, and other programming features to CSS' },
        { id: 'c', text: 'To optimize CSS for mobile devices only' },
        { id: 'd', text: 'To convert HTML to React components' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q14',
      question: 'What is a closure in JavaScript?',
      options: [
        { id: 'a', text: 'A way to close browser tabs programmatically' },
        { id: 'b', text: 'A function with access to variables from its own scope, parent scope, and global scope' },
        { id: 'c', text: 'A method to end JavaScript execution' },
        { id: 'd', text: 'A design pattern for React components' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q15',
      question: 'Which data structure would be most efficient for implementing a priority queue?',
      options: [
        { id: 'a', text: 'Array' },
        { id: 'b', text: 'Linked List' },
        { id: 'c', text: 'Heap' },
        { id: 'd', text: 'Hash Table' }
      ],
      correctAnswer: 'c'
    },
    {
      id: 'q16',
      question: 'What is the purpose of the "useCallback" hook in React?',
      options: [
        { id: 'a', text: 'To memoize functions so they don\'t get recreated on every render' },
        { id: 'b', text: 'To call a function after the component renders' },
        { id: 'c', text: 'To bind event handlers to component instances' },
        { id: 'd', text: 'To create callback functions for API requests' }
      ],
      correctAnswer: 'a'
    },
    {
      id: 'q17',
      question: 'What is the difference between "em" and "rem" units in CSS?',
      options: [
        { id: 'a', text: 'em is relative to the font-size of the element, rem is relative to the root element' },
        { id: 'b', text: 'em is for margins, rem is for padding' },
        { id: 'c', text: 'em is absolute, rem is relative' },
        { id: 'd', text: 'em is for desktop, rem is for mobile' }
      ],
      correctAnswer: 'a'
    },
    {
      id: 'q18',
      question: 'Which HTTP status code indicates a successful response?',
      options: [
        { id: 'a', text: '200' },
        { id: 'b', text: '404' },
        { id: 'c', text: '500' },
        { id: 'd', text: '302' }
      ],
      correctAnswer: 'a'
    },
    {
      id: 'q19',
      question: 'What is the purpose of Git rebase?',
      options: [
        { id: 'a', text: 'To merge two branches' },
        { id: 'b', text: 'To change the base of your branch from one commit to another' },
        { id: 'c', text: 'To reset your repository to a previous state' },
        { id: 'd', text: 'To clone a repository' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q20',
      question: 'Which of the following is NOT a principle of SOLID?',
      options: [
        { id: 'a', text: 'Single Responsibility Principle' },
        { id: 'b', text: 'Open/Closed Principle' },
        { id: 'c', text: 'Dependency Inversion Principle' },
        { id: 'd', text: 'Code Reusability Principle' }
      ],
      correctAnswer: 'd'
    },
    {
      id: 'q21',
      question: 'What is the primary benefit of using TypeScript over JavaScript?',
      options: [
        { id: 'a', text: 'It always runs faster' },
        { id: 'b', text: 'It adds static type checking' },
        { id: 'c', text: 'It has more built-in libraries' },
        { id: 'd', text: 'It requires less system resources' }
      ],
      correctAnswer: 'b'
    },
    {
      id: 'q22',
      question: 'What is memoization in programming?',
      options: [
        { id: 'a', text: 'A technique to optimize performance by caching results of expensive function calls' },
        { id: 'b', text: 'A way to memorize code syntax' },
        { id: 'c', text: 'A design pattern for organizing code' },
        { id: 'd', text: 'A method for encrypting data' }
      ],
      correctAnswer: 'a'
    }
  ],
  descriptive: [
    {
      id: 'd1',
      question: 'Explain how you would approach optimizing the performance of a slow React application.'
    },
    {
      id: 'd2',
      question: 'Describe a challenging project you worked on and how you solved its main problems.'
    },
    {
      id: 'd3',
      question: 'Explain your approach to debugging a complex issue in a web application. What tools and methods would you use?'
    },
    {
      id: 'd4',
      question: 'How would you design a RESTful API for a social media platform? What endpoints would you create and why?'
    },
    {
      id: 'd5',
      question: 'Explain how you would implement authentication and authorization in a modern web application.'
    },
    {
      id: 'd6',
      question: 'Describe your experience with state management in frontend applications. Which approaches do you prefer and why?'
    },
    {
      id: 'd7',
      question: 'How would you approach building a responsive web application that needs to support multiple devices and screen sizes?'
    },
    {
      id: 'd8',
      question: 'Explain your strategy for ensuring code quality and maintainability in a large team environment.'
    },
    {
      id: 'd9',
      question: 'Describe how you would implement a real-time feature (like a chat or notification system) in a web application.'
    },
    {
      id: 'd10',
      question: 'How would you handle error boundaries and fallback UI in a React application?'
    },
    {
      id: 'd11',
      question: 'Explain your approach to testing frontend applications. Which types of tests do you write and why?'
    }
  ],
  personality: [
    {
      id: 'p1',
      question: 'How do you typically handle conflicts within a team?'
    },
    {
      id: 'p2',
      question: 'Describe a situation where you had to adapt to a significant change at work. How did you handle it?'
    },
    {
      id: 'p3',
      question: 'What motivates you the most in your professional life?'
    },
    {
      id: 'p4',
      question: 'How do you prioritize tasks when facing multiple deadlines?'
    },
    {
      id: 'p5',
      question: 'Describe a time when you failed at something. What did you learn from it?'
    },
    {
      id: 'p6',
      question: 'How do you handle feedback, especially when it\'s critical?'
    },
    {
      id: 'p7',
      question: 'What are your strategies for maintaining work-life balance?'
    },
    {
      id: 'p8',
      question: 'Describe your ideal work environment and company culture.'
    },
    {
      id: 'p9',
      question: 'How do you approach learning new skills or technologies?'
    },
    {
      id: 'p10',
      question: 'What leadership qualities do you admire and try to emulate?'
    },
    {
      id: 'p11',
      question: 'How do you contribute to creating an inclusive workplace?'
    },
    {
      id: 'p12',
      question: 'How do you handle situations where you disagree with a superior\'s decision?'
    }
  ]
};

/**
 * Generate job-specific questions based on job area and title
 * This simulates AI-generated questions that would be relevant to the job
 */
export const generateQuestionsForJobArea = (areaName: string, jobTitle: string) => {
  try {
    // In a production app, this would call an AI service or API
    // For now, we'll simulate with predefined questions per area
    
    const areaKey = areaName.toLowerCase();
    let generatedQuestions = {
      mcq: [] as any[],
      descriptive: [] as any[],
      personality: [] as any[]
    };
    
    // Generate area-specific questions - in real implementation, this would call an AI API
    switch (areaKey) {
      case 'engineering':
        generatedQuestions = {
          mcq: [
            {
              id: `eng-mcq-1-${Date.now()}`,
              question: `What pattern would be most appropriate for implementing a notification system in ${jobTitle}?`,
              options: [
                { id: 'a', text: 'Observer pattern' },
                { id: 'b', text: 'Singleton pattern' },
                { id: 'c', text: 'Factory pattern' },
                { id: 'd', text: 'Decorator pattern' }
              ],
              correctAnswer: 'a'
            },
            {
              id: `eng-mcq-2-${Date.now()}`,
              question: 'Which of the following is a benefit of microservices architecture?',
              options: [
                { id: 'a', text: 'Simplified deployment' },
                { id: 'b', text: 'Independent scalability of services' },
                { id: 'c', text: 'Reduced complexity in service communication' },
                { id: 'd', text: 'Lower operational overhead' }
              ],
              correctAnswer: 'b'
            },
            {
              id: `eng-mcq-3-${Date.now()}`,
              question: `What technique would you use to optimize database queries for ${jobTitle}?`,
              options: [
                { id: 'a', text: 'Always use SELECT *' },
                { id: 'b', text: 'Avoid indexing frequently queried columns' },
                { id: 'c', text: 'Use proper indexing and query optimization' },
                { id: 'd', text: 'Always use nested subqueries' }
              ],
              correctAnswer: 'c'
            }
          ],
          descriptive: [
            {
              id: `eng-desc-1-${Date.now()}`,
              question: `Describe how you would implement a scalable architecture for a ${jobTitle} project with rapidly growing user base.`
            },
            {
              id: `eng-desc-2-${Date.now()}`,
              question: `How would you handle technical debt in a large codebase as a ${jobTitle}?`
            }
          ],
          personality: [
            {
              id: `eng-per-1-${Date.now()}`,
              question: `As a ${jobTitle}, how do you balance technical excellence with meeting project deadlines?`
            },
            {
              id: `eng-per-2-${Date.now()}`,
              question: `Describe a situation where you had to convince your team to adopt a new technology or approach.`
            },
            {
              id: `eng-per-3-${Date.now()}`,
              question: `How do you handle technical disagreements within a team?`
            }
          ]
        };
        break;
        
      case 'design':
        generatedQuestions = {
          mcq: [
            {
              id: `design-mcq-1-${Date.now()}`,
              question: 'Which of the following is a key principle of user-centered design?',
              options: [
                { id: 'a', text: 'Focusing primarily on aesthetics' },
                { id: 'b', text: 'Early and continual focus on users and their tasks' },
                { id: 'c', text: 'Minimizing user testing to speed up development' },
                { id: 'd', text: 'Implementing all feature requests from stakeholders' }
              ],
              correctAnswer: 'b'
            },
            {
              id: `design-mcq-2-${Date.now()}`,
              question: `Which color model would be most appropriate for ${jobTitle} work targeting digital screens?`,
              options: [
                { id: 'a', text: 'CMYK' },
                { id: 'b', text: 'RGB' },
                { id: 'c', text: 'Pantone' },
                { id: 'd', text: 'HSL' }
              ],
              correctAnswer: 'b'
            }
          ],
          descriptive: [
            {
              id: `design-desc-1-${Date.now()}`,
              question: `Describe your process for creating a new user interface for a complex feature as a ${jobTitle}.`
            },
            {
              id: `design-desc-2-${Date.now()}`,
              question: 'How do you balance aesthetic considerations with usability and accessibility requirements?'
            }
          ],
          personality: [
            {
              id: `design-per-1-${Date.now()}`,
              question: `How do you handle feedback on your designs, especially when it's negative?`
            },
            {
              id: `design-per-2-${Date.now()}`,
              question: `How do you balance creativity with business requirements in your role as a ${jobTitle}?`
            },
            {
              id: `design-per-3-${Date.now()}`,
              question: `Describe a situation where you had to defend your design decisions to stakeholders.`
            }
          ]
        };
        break;
        
      case 'marketing':
        generatedQuestions = {
          mcq: [
            {
              id: `mkt-mcq-1-${Date.now()}`,
              question: 'Which of the following metrics is most important for evaluating email marketing campaigns?',
              options: [
                { id: 'a', text: 'Open rate' },
                { id: 'b', text: 'Click-through rate' },
                { id: 'c', text: 'Conversion rate' },
                { id: 'd', text: 'Number of emails sent' }
              ],
              correctAnswer: 'c'
            },
            {
              id: `mkt-mcq-2-${Date.now()}`,
              question: `What is a key consideration when developing a content strategy for ${jobTitle}?`,
              options: [
                { id: 'a', text: 'Focusing only on product features' },
                { id: 'b', text: 'Creating content without defined audience personas' },
                { id: 'c', text: 'Aligning content with customer journey stages' },
                { id: 'd', text: 'Prioritizing quantity over quality' }
              ],
              correctAnswer: 'c'
            }
          ],
          descriptive: [
            {
              id: `mkt-desc-1-${Date.now()}`,
              question: `How would you develop and execute a marketing campaign for a new product launch as a ${jobTitle}?`
            },
            {
              id: `mkt-desc-2-${Date.now()}`,
              question: 'Describe your approach to measuring and reporting marketing ROI to stakeholders.'
            }
          ],
          personality: [
            {
              id: `mkt-per-1-${Date.now()}`,
              question: `How do you stay creative and generate fresh ideas as a ${jobTitle}?`
            },
            {
              id: `mkt-per-2-${Date.now()}`,
              question: `Describe a time when a marketing campaign didn't perform as expected. How did you handle it?`
            },
            {
              id: `mkt-per-3-${Date.now()}`,
              question: `How do you balance data-driven decisions with creative intuition?`
            }
          ]
        };
        break;
        
      case 'sales':
        generatedQuestions = {
          mcq: [
            {
              id: `sales-mcq-1-${Date.now()}`,
              question: 'Which of the following is most important in the qualification stage of a B2B sales process?',
              options: [
                { id: 'a', text: 'Determining budget authority' },
                { id: 'b', text: 'Discussing technical specifications' },
                { id: 'c', text: 'Sending a formal proposal' },
                { id: 'd', text: 'Negotiating final price' }
              ],
              correctAnswer: 'a'
            },
            {
              id: `sales-mcq-2-${Date.now()}`,
              question: `What sales methodology would be most effective for ${jobTitle} with complex, high-value products?`,
              options: [
                { id: 'a', text: 'Transactional selling' },
                { id: 'b', text: 'Solution selling' },
                { id: 'c', text: 'Door-to-door selling' },
                { id: 'd', text: 'High-pressure closing techniques' }
              ],
              correctAnswer: 'b'
            }
          ],
          descriptive: [
            {
              id: `sales-desc-1-${Date.now()}`,
              question: `How would you handle objections about pricing as a ${jobTitle}?`
            },
            {
              id: `sales-desc-2-${Date.now()}`,
              question: 'Describe your approach to building and maintaining long-term client relationships.'
            }
          ],
          personality: [
            {
              id: `sales-per-1-${Date.now()}`,
              question: `How do you handle rejection from potential clients?`
            },
            {
              id: `sales-per-2-${Date.now()}`,
              question: `Describe your approach to building rapport with new prospects as a ${jobTitle}.`
            },
            {
              id: `sales-per-3-${Date.now()}`,
              question: `How do you maintain motivation during slow sales periods?`
            }
          ]
        };
        break;
        
      default:
        // Use generic questions for other areas
        generatedQuestions = {
          mcq: [
            {
              id: `gen-mcq-1-${Date.now()}`,
              question: `What key skills are most important for success as a ${jobTitle}?`,
              options: [
                { id: 'a', text: 'Technical expertise' },
                { id: 'b', text: 'Communication skills' },
                { id: 'c', text: 'Problem-solving ability' },
                { id: 'd', text: 'All of the above' }
              ],
              correctAnswer: 'd'
            },
            {
              id: `gen-mcq-2-${Date.now()}`,
              question: 'Which approach is best for managing team conflicts?',
              options: [
                { id: 'a', text: 'Avoiding the conflict' },
                { id: 'b', text: 'Addressing issues directly and professionally' },
                { id: 'c', text: 'Letting management handle all conflicts' },
                { id: 'd', text: 'Taking sides with the majority' }
              ],
              correctAnswer: 'b'
            }
          ],
          descriptive: [
            {
              id: `gen-desc-1-${Date.now()}`,
              question: `Describe a challenging situation you faced in a previous role similar to ${jobTitle} and how you resolved it.`
            },
            {
              id: `gen-desc-2-${Date.now()}`,
              question: `How would your skills and experience contribute to success in this ${jobTitle} position?`
            }
          ],
          personality: [
            {
              id: `gen-per-1-${Date.now()}`,
              question: `What values do you look for in a company and how do they align with your personal values?`
            },
            {
              id: `gen-per-2-${Date.now()}`,
              question: `How do you approach collaboration with colleagues from different departments?`
            },
            {
              id: `gen-per-3-${Date.now()}`,
              question: `Describe a situation where you went above and beyond for your job.`
            }
          ]
        };
    }
    
    // Store the generated questions
    jobSpecificQuestions.set(`${areaKey}-${jobTitle.toLowerCase().replace(/\s+/g, '-')}`, generatedQuestions);
    
    // Add these questions to the main pool
    assessmentQuestionPool.mcq = [
      ...assessmentQuestionPool.mcq,
      ...generatedQuestions.mcq
    ];
    
    assessmentQuestionPool.descriptive = [
      ...assessmentQuestionPool.descriptive,
      ...generatedQuestions.descriptive
    ];
    
    if (!assessmentQuestionPool.personality) {
      assessmentQuestionPool.personality = [];
    }
    
    assessmentQuestionPool.personality = [
      ...assessmentQuestionPool.personality,
      ...generatedQuestions.personality
    ];
    
    // Notify user about question generation (optional)
    toast.success(`Assessment questions generated for ${jobTitle}`, {
      position: 'bottom-right',
      duration: 3000
    });
    
    return generatedQuestions;
  } catch (error) {
    console.error('Error generating questions:', error);
    toast.error('Failed to generate assessment questions', {
      position: 'bottom-right',
      duration: 3000
    });
    return null;
  }
};

// Update to include personality questions
export const getAssessmentQuestions = () => {
  const mcqs = assessmentQuestionPool.mcq.length > 20 
    ? [...assessmentQuestionPool.mcq].sort(() => 0.5 - Math.random()).slice(0, 20)
    : [...assessmentQuestionPool.mcq];
    
  const descriptive = assessmentQuestionPool.descriptive.length > 5
    ? [...assessmentQuestionPool.descriptive].sort(() => 0.5 - Math.random()).slice(0, 5)
    : [...assessmentQuestionPool.descriptive];
  
  const personality = assessmentQuestionPool.personality && assessmentQuestionPool.personality.length > 3
    ? [...assessmentQuestionPool.personality].sort(() => 0.5 - Math.random()).slice(0, 3)
    : assessmentQuestionPool.personality || [];
  
  return { mcqs, descriptive, personality };
};

// Simple AI content detection utility
// In a real implementation, this would call an API that uses more sophisticated detection

/**
 * Checks if the given text appears to be AI-generated
 * @param text The text to check
 * @returns Promise resolving to a result object with isAIGenerated flag
 */
export const checkAIContent = async (text: string): Promise<{ isAIGenerated: boolean, score: number }> => {
  // In a production app, this would call a backend service or API for AI detection
  // For demo purposes, we're implementing a basic heuristic check
  
  // Simple naive implementation for demonstration
  // In a real app, use a proper AI detection service
  
  if (!text || text.length < 100) {
    return { isAIGenerated: false, score: 0 };
  }
  
  // Some basic heuristics
  let aiScore = 0;
  
  // Check for unnaturally perfect structure
  const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 0);
  const avgSentenceLength = text.length / sentences.length;
  
  // Unnaturally consistent sentence length
  const sentenceLengths = sentences.map(s => s.trim().length);
  const sentenceLengthVariance = calculateVariance(sentenceLengths);
  
  if (avgSentenceLength > 25 && sentenceLengthVariance < 100) {
    aiScore += 0.2;
  }
  
  // Check for complex vocabulary or formal language patterns
  const complexWords = ["furthermore", "additionally", "consequently", "therefore", "however", "nevertheless", "moreover"];
  const complexWordCount = complexWords.reduce((count, word) => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    return count + (text.match(regex)?.length || 0);
  }, 0);
  
  if (complexWordCount / sentences.length > 0.2) {
    aiScore += 0.3;
  }
  
  // Check for lack of personal pronouns (I, me, my, etc.) in descriptive/personal questions
  const personalPronouns = ["i", "me", "my", "mine", "myself"];
  const hasPersonalPronouns = personalPronouns.some(pronoun => {
    const regex = new RegExp(`\\b${pronoun}\\b`, 'i');
    return regex.test(text);
  });
  
  if (!hasPersonalPronouns && text.length > 200) {
    aiScore += 0.3;
  }
  
  // For demo purposes, check if content seems unusually polished
  const isVeryPolished = sentences.every(s => s.trim().length > 5 && /[,.;:]/.test(s));
  if (isVeryPolished) {
    aiScore += 0.2;
  }
  
  // Mimic some API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  return { 
    isAIGenerated: aiScore > 0.5,
    score: aiScore 
  };
};

// Helper function to calculate variance
function calculateVariance(array: number[]): number {
  const n = array.length;
  if (n === 0) return 0;
  
  const mean = array.reduce((a, b) => a + b, 0) / n;
  const variance = array.reduce((a, b) => a + Math.pow(b - mean, 2), 0) / n;
  
  return variance;
}
